import {
    UPDATE_CONSIGNMENT_DETAILS,
    UPDATE_CONSIGNMENT_DETAILS_SUCCESS,
    UPDATE_CONSIGNMENT_DETAILS_FAILURE,
    RESET_CREATE_UPDATE_CONSIGNMENT,
} from '../actions';

const initialState = {
    updateConsignment: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    updateConsignmentLoading: false,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const updateConsignmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_CONSIGNMENT_DETAILS:
            return {
                ...state,
                updateConsignmentLoading: true,
            };
        case UPDATE_CONSIGNMENT_DETAILS_SUCCESS:
            return {
                ...state,
                updateConsignment: {
                    data: action.data,
                    statusCode: '200',
                },
                updateConsignmentLoading: false,
            };
        case UPDATE_CONSIGNMENT_DETAILS_FAILURE:
            return {
                ...state,
                updateConsignment: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                updateConsignmentLoading: false,
            };
        case RESET_CREATE_UPDATE_CONSIGNMENT:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'updateConsignmentKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    updateConsignmentReducer
);
